"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: area_page.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaPageListing_IntegerRange = exports.AreaPageListing = exports.AreaPageListingResponse = exports.AreaPageListingRequest = exports.Filter = exports.TypeOfProperty = exports.Range_Float = exports.Range_Date = exports.Range_Integer = exports.Range = exports.AreaPageListing_Status = exports.AreaPageListing_ListingType = exports.PropertyType = exports.Style = exports.SortBy = exports.protobufPackage = void 0;
exports.sortByFromJSON = sortByFromJSON;
exports.sortByToJSON = sortByToJSON;
exports.styleFromJSON = styleFromJSON;
exports.styleToJSON = styleToJSON;
exports.propertyTypeFromJSON = propertyTypeFromJSON;
exports.propertyTypeToJSON = propertyTypeToJSON;
exports.areaPageListing_ListingTypeFromJSON = areaPageListing_ListingTypeFromJSON;
exports.areaPageListing_ListingTypeToJSON = areaPageListing_ListingTypeToJSON;
exports.areaPageListing_StatusFromJSON = areaPageListing_StatusFromJSON;
exports.areaPageListing_StatusToJSON = areaPageListing_StatusToJSON;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const timestamp_1 = require("../google/protobuf/timestamp");
const display_1 = require("../property/display");
const provider_1 = require("../property/provider");
const standard_status_1 = require("../property/standard_status");
exports.protobufPackage = "domain";
var SortBy;
(function (SortBy) {
    SortBy[SortBy["NotSet"] = 0] = "NotSet";
    SortBy[SortBy["PriceAsc"] = 1] = "PriceAsc";
    SortBy[SortBy["PriceDesc"] = 2] = "PriceDesc";
    SortBy[SortBy["DateAsd"] = 3] = "DateAsd";
    SortBy[SortBy["DateDesc"] = 4] = "DateDesc";
    SortBy[SortBy["BedroomsDesc"] = 5] = "BedroomsDesc";
    SortBy[SortBy["BedroomsAsc"] = 6] = "BedroomsAsc";
    SortBy[SortBy["BathroomsDesc"] = 7] = "BathroomsDesc";
    SortBy[SortBy["BathroomsAsc"] = 8] = "BathroomsAsc";
    SortBy[SortBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SortBy || (exports.SortBy = SortBy = {}));
function sortByFromJSON(object) {
    switch (object) {
        case 0:
        case "NotSet":
            return SortBy.NotSet;
        case 1:
        case "PriceAsc":
            return SortBy.PriceAsc;
        case 2:
        case "PriceDesc":
            return SortBy.PriceDesc;
        case 3:
        case "DateAsd":
            return SortBy.DateAsd;
        case 4:
        case "DateDesc":
            return SortBy.DateDesc;
        case 5:
        case "BedroomsDesc":
            return SortBy.BedroomsDesc;
        case 6:
        case "BedroomsAsc":
            return SortBy.BedroomsAsc;
        case 7:
        case "BathroomsDesc":
            return SortBy.BathroomsDesc;
        case 8:
        case "BathroomsAsc":
            return SortBy.BathroomsAsc;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SortBy.UNRECOGNIZED;
    }
}
function sortByToJSON(object) {
    switch (object) {
        case SortBy.NotSet:
            return "NotSet";
        case SortBy.PriceAsc:
            return "PriceAsc";
        case SortBy.PriceDesc:
            return "PriceDesc";
        case SortBy.DateAsd:
            return "DateAsd";
        case SortBy.DateDesc:
            return "DateDesc";
        case SortBy.BedroomsDesc:
            return "BedroomsDesc";
        case SortBy.BedroomsAsc:
            return "BedroomsAsc";
        case SortBy.BathroomsDesc:
            return "BathroomsDesc";
        case SortBy.BathroomsAsc:
            return "BathroomsAsc";
        case SortBy.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Style;
(function (Style) {
    Style[Style["All"] = 0] = "All";
    /** vacant_land - Vacant Land */
    Style[Style["vacant_land"] = 111] = "vacant_land";
    Style[Style["other_unspecified"] = 24] = "other_unspecified";
    /** house_detached - Free-standing residential buildings. */
    Style[Style["house_detached"] = 101] = "house_detached";
    /** house_attached - Includes semi-detached homes and row or town houses. */
    Style[Style["house_attached"] = 102] = "house_attached";
    /** house_new_development - Houses which are newly built or under construction. */
    Style[Style["house_new_development"] = 103] = "house_new_development";
    /** house_other - Other */
    Style[Style["house_other"] = 104] = "house_other";
    /** condo_highrise - Individually owned residential units in tall apartment buildings or structures. */
    Style[Style["condo_highrise"] = 105] = "condo_highrise";
    /** condo_lowrise - Individually owned residences that are only a few stories tall, such as townhouses. */
    Style[Style["condo_lowrise"] = 106] = "condo_lowrise";
    /** condo_new_development - Condos which are newly built, planned or under construction. */
    Style[Style["condo_new_development"] = 107] = "condo_new_development";
    /** condo_other - Other */
    Style[Style["condo_other"] = 108] = "condo_other";
    /** townhouse - Condo townhouses */
    Style[Style["townhouse"] = 109] = "townhouse";
    /** house_semidetached - Semi-detached homes */
    Style[Style["house_semidetached"] = 110] = "house_semidetached";
    /** multifamily_other - Multifamily homes */
    Style[Style["multifamily_other"] = 112] = "multifamily_other";
    Style[Style["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Style || (exports.Style = Style = {}));
function styleFromJSON(object) {
    switch (object) {
        case 0:
        case "All":
            return Style.All;
        case 111:
        case "vacant_land":
            return Style.vacant_land;
        case 24:
        case "other_unspecified":
            return Style.other_unspecified;
        case 101:
        case "house_detached":
            return Style.house_detached;
        case 102:
        case "house_attached":
            return Style.house_attached;
        case 103:
        case "house_new_development":
            return Style.house_new_development;
        case 104:
        case "house_other":
            return Style.house_other;
        case 105:
        case "condo_highrise":
            return Style.condo_highrise;
        case 106:
        case "condo_lowrise":
            return Style.condo_lowrise;
        case 107:
        case "condo_new_development":
            return Style.condo_new_development;
        case 108:
        case "condo_other":
            return Style.condo_other;
        case 109:
        case "townhouse":
            return Style.townhouse;
        case 110:
        case "house_semidetached":
            return Style.house_semidetached;
        case 112:
        case "multifamily_other":
            return Style.multifamily_other;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Style.UNRECOGNIZED;
    }
}
function styleToJSON(object) {
    switch (object) {
        case Style.All:
            return "All";
        case Style.vacant_land:
            return "vacant_land";
        case Style.other_unspecified:
            return "other_unspecified";
        case Style.house_detached:
            return "house_detached";
        case Style.house_attached:
            return "house_attached";
        case Style.house_new_development:
            return "house_new_development";
        case Style.house_other:
            return "house_other";
        case Style.condo_highrise:
            return "condo_highrise";
        case Style.condo_lowrise:
            return "condo_lowrise";
        case Style.condo_new_development:
            return "condo_new_development";
        case Style.condo_other:
            return "condo_other";
        case Style.townhouse:
            return "townhouse";
        case Style.house_semidetached:
            return "house_semidetached";
        case Style.multifamily_other:
            return "multifamily_other";
        case Style.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["singleFamily"] = 0] = "singleFamily";
    PropertyType[PropertyType["singleFamilyAndBasement"] = 1] = "singleFamilyAndBasement";
    PropertyType[PropertyType["duplex"] = 2] = "duplex";
    PropertyType[PropertyType["triplex"] = 3] = "triplex";
    PropertyType[PropertyType["fourplex"] = 4] = "fourplex";
    PropertyType[PropertyType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PropertyType || (exports.PropertyType = PropertyType = {}));
function propertyTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "singleFamily":
            return PropertyType.singleFamily;
        case 1:
        case "singleFamilyAndBasement":
            return PropertyType.singleFamilyAndBasement;
        case 2:
        case "duplex":
            return PropertyType.duplex;
        case 3:
        case "triplex":
            return PropertyType.triplex;
        case 4:
        case "fourplex":
            return PropertyType.fourplex;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PropertyType.UNRECOGNIZED;
    }
}
function propertyTypeToJSON(object) {
    switch (object) {
        case PropertyType.singleFamily:
            return "singleFamily";
        case PropertyType.singleFamilyAndBasement:
            return "singleFamilyAndBasement";
        case PropertyType.duplex:
            return "duplex";
        case PropertyType.triplex:
            return "triplex";
        case PropertyType.fourplex:
            return "fourplex";
        case PropertyType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var AreaPageListing_ListingType;
(function (AreaPageListing_ListingType) {
    AreaPageListing_ListingType[AreaPageListing_ListingType["Unspecified"] = 0] = "Unspecified";
    AreaPageListing_ListingType[AreaPageListing_ListingType["rent"] = 1] = "rent";
    AreaPageListing_ListingType[AreaPageListing_ListingType["buy"] = 2] = "buy";
    AreaPageListing_ListingType[AreaPageListing_ListingType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AreaPageListing_ListingType || (exports.AreaPageListing_ListingType = AreaPageListing_ListingType = {}));
function areaPageListing_ListingTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "Unspecified":
            return AreaPageListing_ListingType.Unspecified;
        case 1:
        case "rent":
            return AreaPageListing_ListingType.rent;
        case 2:
        case "buy":
            return AreaPageListing_ListingType.buy;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AreaPageListing_ListingType.UNRECOGNIZED;
    }
}
function areaPageListing_ListingTypeToJSON(object) {
    switch (object) {
        case AreaPageListing_ListingType.Unspecified:
            return "Unspecified";
        case AreaPageListing_ListingType.rent:
            return "rent";
        case AreaPageListing_ListingType.buy:
            return "buy";
        case AreaPageListing_ListingType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var AreaPageListing_Status;
(function (AreaPageListing_Status) {
    AreaPageListing_Status[AreaPageListing_Status["Unknown"] = 0] = "Unknown";
    AreaPageListing_Status[AreaPageListing_Status["Deleted"] = -1] = "Deleted";
    /** Duplicate - duplicate found marking before deleting. */
    AreaPageListing_Status[AreaPageListing_Status["Duplicate"] = -10] = "Duplicate";
    AreaPageListing_Status[AreaPageListing_Status["Available"] = 1] = "Available";
    AreaPageListing_Status[AreaPageListing_Status["NotAvailable"] = 2] = "NotAvailable";
    /** NotAvailableSold - Not available, sold. */
    AreaPageListing_Status[AreaPageListing_Status["NotAvailableSold"] = 3] = "NotAvailableSold";
    /** NotAvailableOther - Not available, not sold. */
    AreaPageListing_Status[AreaPageListing_Status["NotAvailableOther"] = 4] = "NotAvailableOther";
    /** NoGeometryData - The property cannot be geolocated and has not geolocation data. */
    AreaPageListing_Status[AreaPageListing_Status["NoGeometryData"] = -2] = "NoGeometryData";
})(AreaPageListing_Status || (exports.AreaPageListing_Status = AreaPageListing_Status = {}));
function areaPageListing_StatusFromJSON(object) {
    switch (object) {
        case 0:
        case "Unknown":
            return AreaPageListing_Status.Unknown;
        case -1:
        case "Deleted":
            return AreaPageListing_Status.Deleted;
        case -10:
        case "Duplicate":
            return AreaPageListing_Status.Duplicate;
        case 1:
        case "Available":
            return AreaPageListing_Status.Available;
        case 2:
        case "NotAvailable":
            return AreaPageListing_Status.NotAvailable;
        case 3:
        case "NotAvailableSold":
            return AreaPageListing_Status.NotAvailableSold;
        case 4:
        case "NotAvailableOther":
            return AreaPageListing_Status.NotAvailableOther;
        case -2:
        case "NoGeometryData":
            return AreaPageListing_Status.NoGeometryData;
        default:
            return AreaPageListing_Status.Deleted;
    }
}
function areaPageListing_StatusToJSON(object) {
    switch (object) {
        case AreaPageListing_Status.Unknown:
            return "Unknown";
        case AreaPageListing_Status.Deleted:
            return "Deleted";
        case AreaPageListing_Status.Duplicate:
            return "Duplicate";
        case AreaPageListing_Status.Available:
            return "Available";
        case AreaPageListing_Status.NotAvailable:
            return "NotAvailable";
        case AreaPageListing_Status.NotAvailableSold:
            return "NotAvailableSold";
        case AreaPageListing_Status.NotAvailableOther:
            return "NotAvailableOther";
        case AreaPageListing_Status.NoGeometryData:
            return "NoGeometryData";
        default:
            return "Deleted";
    }
}
function createBaseRange() {
    return {};
}
exports.Range = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.Range.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseRange();
        return message;
    },
};
function createBaseRange_Integer() {
    return { gt: undefined, gte: undefined, lt: undefined, lte: undefined };
}
exports.Range_Integer = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.gt !== undefined) {
            writer.uint32(8).int32(message.gt);
        }
        if (message.gte !== undefined) {
            writer.uint32(16).int32(message.gte);
        }
        if (message.lt !== undefined) {
            writer.uint32(24).int32(message.lt);
        }
        if (message.lte !== undefined) {
            writer.uint32(32).int32(message.lte);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRange_Integer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.gt = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.gte = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.lt = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.lte = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            gt: isSet(object.gt) ? globalThis.Number(object.gt) : undefined,
            gte: isSet(object.gte) ? globalThis.Number(object.gte) : undefined,
            lt: isSet(object.lt) ? globalThis.Number(object.lt) : undefined,
            lte: isSet(object.lte) ? globalThis.Number(object.lte) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.gt !== undefined) {
            obj.gt = Math.round(message.gt);
        }
        if (message.gte !== undefined) {
            obj.gte = Math.round(message.gte);
        }
        if (message.lt !== undefined) {
            obj.lt = Math.round(message.lt);
        }
        if (message.lte !== undefined) {
            obj.lte = Math.round(message.lte);
        }
        return obj;
    },
    create(base) {
        return exports.Range_Integer.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseRange_Integer();
        message.gt = (_a = object.gt) !== null && _a !== void 0 ? _a : undefined;
        message.gte = (_b = object.gte) !== null && _b !== void 0 ? _b : undefined;
        message.lt = (_c = object.lt) !== null && _c !== void 0 ? _c : undefined;
        message.lte = (_d = object.lte) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function createBaseRange_Date() {
    return { gt: undefined, gte: undefined, lt: undefined, lte: undefined, timeZone: undefined };
}
exports.Range_Date = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.gt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.gt), writer.uint32(10).fork()).join();
        }
        if (message.gte !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.gte), writer.uint32(18).fork()).join();
        }
        if (message.lt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lt), writer.uint32(26).fork()).join();
        }
        if (message.lte !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lte), writer.uint32(34).fork()).join();
        }
        if (message.timeZone !== undefined) {
            writer.uint32(42).string(message.timeZone);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRange_Date();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.gt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.gte = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.lt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.lte = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.timeZone = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            gt: isSet(object.gt) ? fromJsonTimestamp(object.gt) : undefined,
            gte: isSet(object.gte) ? fromJsonTimestamp(object.gte) : undefined,
            lt: isSet(object.lt) ? fromJsonTimestamp(object.lt) : undefined,
            lte: isSet(object.lte) ? fromJsonTimestamp(object.lte) : undefined,
            timeZone: isSet(object.time_zone) ? globalThis.String(object.time_zone) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.gt !== undefined) {
            obj.gt = message.gt.toISOString();
        }
        if (message.gte !== undefined) {
            obj.gte = message.gte.toISOString();
        }
        if (message.lt !== undefined) {
            obj.lt = message.lt.toISOString();
        }
        if (message.lte !== undefined) {
            obj.lte = message.lte.toISOString();
        }
        if (message.timeZone !== undefined) {
            obj.time_zone = message.timeZone;
        }
        return obj;
    },
    create(base) {
        return exports.Range_Date.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseRange_Date();
        message.gt = (_a = object.gt) !== null && _a !== void 0 ? _a : undefined;
        message.gte = (_b = object.gte) !== null && _b !== void 0 ? _b : undefined;
        message.lt = (_c = object.lt) !== null && _c !== void 0 ? _c : undefined;
        message.lte = (_d = object.lte) !== null && _d !== void 0 ? _d : undefined;
        message.timeZone = (_e = object.timeZone) !== null && _e !== void 0 ? _e : undefined;
        return message;
    },
};
function createBaseRange_Float() {
    return { gt: undefined, gte: undefined, lt: undefined, lte: undefined };
}
exports.Range_Float = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.gt !== undefined) {
            writer.uint32(13).float(message.gt);
        }
        if (message.gte !== undefined) {
            writer.uint32(21).float(message.gte);
        }
        if (message.lt !== undefined) {
            writer.uint32(29).float(message.lt);
        }
        if (message.lte !== undefined) {
            writer.uint32(37).float(message.lte);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRange_Float();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 13) {
                        break;
                    }
                    message.gt = reader.float();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.gte = reader.float();
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.lt = reader.float();
                    continue;
                }
                case 4: {
                    if (tag !== 37) {
                        break;
                    }
                    message.lte = reader.float();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            gt: isSet(object.gt) ? globalThis.Number(object.gt) : undefined,
            gte: isSet(object.gte) ? globalThis.Number(object.gte) : undefined,
            lt: isSet(object.lt) ? globalThis.Number(object.lt) : undefined,
            lte: isSet(object.lte) ? globalThis.Number(object.lte) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.gt !== undefined) {
            obj.gt = message.gt;
        }
        if (message.gte !== undefined) {
            obj.gte = message.gte;
        }
        if (message.lt !== undefined) {
            obj.lt = message.lt;
        }
        if (message.lte !== undefined) {
            obj.lte = message.lte;
        }
        return obj;
    },
    create(base) {
        return exports.Range_Float.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseRange_Float();
        message.gt = (_a = object.gt) !== null && _a !== void 0 ? _a : undefined;
        message.gte = (_b = object.gte) !== null && _b !== void 0 ? _b : undefined;
        message.lt = (_c = object.lt) !== null && _c !== void 0 ? _c : undefined;
        message.lte = (_d = object.lte) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function createBaseTypeOfProperty() {
    return { propertyTypes: [], propertySubTypes: [] };
}
exports.TypeOfProperty = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.propertyTypes) {
            writer.uint32(10).string(v);
        }
        for (const v of message.propertySubTypes) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTypeOfProperty();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.propertyTypes.push(reader.string());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.propertySubTypes.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            propertyTypes: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.propertyTypes)
                ? object.propertyTypes.map((e) => globalThis.String(e))
                : [],
            propertySubTypes: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.propertySubTypes)
                ? object.propertySubTypes.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        var _a, _b;
        const obj = {};
        if ((_a = message.propertyTypes) === null || _a === void 0 ? void 0 : _a.length) {
            obj.propertyTypes = message.propertyTypes;
        }
        if ((_b = message.propertySubTypes) === null || _b === void 0 ? void 0 : _b.length) {
            obj.propertySubTypes = message.propertySubTypes;
        }
        return obj;
    },
    create(base) {
        return exports.TypeOfProperty.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseTypeOfProperty();
        message.propertyTypes = ((_a = object.propertyTypes) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.propertySubTypes = ((_b = object.propertySubTypes) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseFilter() {
    return {
        listingType: 0,
        statusId: 0,
        price: undefined,
        styles: [],
        listedDate: undefined,
        bedroomsExact: undefined,
        bedroomsRange: undefined,
        bathroomsExact: undefined,
        bathroomsRange: undefined,
        parkingExact: undefined,
        parkingRange: undefined,
        squareFeet: undefined,
        propertyType: [],
        hasGarage: false,
        hasPool: false,
        hasOpenHouse: false,
        hasWaterFront: false,
        hasFirePlace: false,
        hasLocker: false,
        maintenance: 0,
        boundaryTopLeft: [],
        boundaryBottomRight: [],
        zoom: 0,
        providerId: 0,
        hasImage: false,
        typeOfProperty: [],
        standardStatus: 0,
    };
}
exports.Filter = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.listingType !== 0) {
            writer.uint32(8).int32(message.listingType);
        }
        if (message.statusId !== 0) {
            writer.uint32(16).int32(message.statusId);
        }
        if (message.price !== undefined) {
            exports.Range_Float.encode(message.price, writer.uint32(26).fork()).join();
        }
        writer.uint32(34).fork();
        for (const v of message.styles) {
            writer.int32(v);
        }
        writer.join();
        if (message.listedDate !== undefined) {
            exports.Range_Date.encode(message.listedDate, writer.uint32(42).fork()).join();
        }
        if (message.bedroomsExact !== undefined) {
            writer.uint32(48).uint32(message.bedroomsExact);
        }
        if (message.bedroomsRange !== undefined) {
            exports.Range_Integer.encode(message.bedroomsRange, writer.uint32(58).fork()).join();
        }
        if (message.bathroomsExact !== undefined) {
            writer.uint32(64).uint32(message.bathroomsExact);
        }
        if (message.bathroomsRange !== undefined) {
            exports.Range_Integer.encode(message.bathroomsRange, writer.uint32(74).fork()).join();
        }
        if (message.parkingExact !== undefined) {
            writer.uint32(80).uint32(message.parkingExact);
        }
        if (message.parkingRange !== undefined) {
            exports.Range_Integer.encode(message.parkingRange, writer.uint32(90).fork()).join();
        }
        if (message.squareFeet !== undefined) {
            exports.Range_Float.encode(message.squareFeet, writer.uint32(98).fork()).join();
        }
        writer.uint32(106).fork();
        for (const v of message.propertyType) {
            writer.int32(v);
        }
        writer.join();
        if (message.hasGarage !== false) {
            writer.uint32(112).bool(message.hasGarage);
        }
        if (message.hasPool !== false) {
            writer.uint32(120).bool(message.hasPool);
        }
        if (message.hasOpenHouse !== false) {
            writer.uint32(128).bool(message.hasOpenHouse);
        }
        if (message.hasWaterFront !== false) {
            writer.uint32(136).bool(message.hasWaterFront);
        }
        if (message.hasFirePlace !== false) {
            writer.uint32(144).bool(message.hasFirePlace);
        }
        if (message.hasLocker !== false) {
            writer.uint32(152).bool(message.hasLocker);
        }
        if (message.maintenance !== 0) {
            writer.uint32(165).float(message.maintenance);
        }
        writer.uint32(170).fork();
        for (const v of message.boundaryTopLeft) {
            writer.float(v);
        }
        writer.join();
        writer.uint32(178).fork();
        for (const v of message.boundaryBottomRight) {
            writer.float(v);
        }
        writer.join();
        if (message.zoom !== 0) {
            writer.uint32(189).float(message.zoom);
        }
        if (message.providerId !== 0) {
            writer.uint32(208).int32(message.providerId);
        }
        if (message.hasImage !== false) {
            writer.uint32(216).bool(message.hasImage);
        }
        for (const v of message.typeOfProperty) {
            exports.TypeOfProperty.encode(v, writer.uint32(226).fork()).join();
        }
        if (message.standardStatus !== 0) {
            writer.uint32(232).int32(message.standardStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.listingType = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.statusId = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.price = exports.Range_Float.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag === 32) {
                        message.styles.push(reader.int32());
                        continue;
                    }
                    if (tag === 34) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.styles.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.listedDate = exports.Range_Date.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.bedroomsExact = reader.uint32();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.bedroomsRange = exports.Range_Integer.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.bathroomsExact = reader.uint32();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.bathroomsRange = exports.Range_Integer.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.parkingExact = reader.uint32();
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.parkingRange = exports.Range_Integer.decode(reader, reader.uint32());
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.squareFeet = exports.Range_Float.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag === 104) {
                        message.propertyType.push(reader.int32());
                        continue;
                    }
                    if (tag === 106) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.propertyType.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
                case 14: {
                    if (tag !== 112) {
                        break;
                    }
                    message.hasGarage = reader.bool();
                    continue;
                }
                case 15: {
                    if (tag !== 120) {
                        break;
                    }
                    message.hasPool = reader.bool();
                    continue;
                }
                case 16: {
                    if (tag !== 128) {
                        break;
                    }
                    message.hasOpenHouse = reader.bool();
                    continue;
                }
                case 17: {
                    if (tag !== 136) {
                        break;
                    }
                    message.hasWaterFront = reader.bool();
                    continue;
                }
                case 18: {
                    if (tag !== 144) {
                        break;
                    }
                    message.hasFirePlace = reader.bool();
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.hasLocker = reader.bool();
                    continue;
                }
                case 20: {
                    if (tag !== 165) {
                        break;
                    }
                    message.maintenance = reader.float();
                    continue;
                }
                case 21: {
                    if (tag === 173) {
                        message.boundaryTopLeft.push(reader.float());
                        continue;
                    }
                    if (tag === 170) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.boundaryTopLeft.push(reader.float());
                        }
                        continue;
                    }
                    break;
                }
                case 22: {
                    if (tag === 181) {
                        message.boundaryBottomRight.push(reader.float());
                        continue;
                    }
                    if (tag === 178) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.boundaryBottomRight.push(reader.float());
                        }
                        continue;
                    }
                    break;
                }
                case 23: {
                    if (tag !== 189) {
                        break;
                    }
                    message.zoom = reader.float();
                    continue;
                }
                case 26: {
                    if (tag !== 208) {
                        break;
                    }
                    message.providerId = reader.int32();
                    continue;
                }
                case 27: {
                    if (tag !== 216) {
                        break;
                    }
                    message.hasImage = reader.bool();
                    continue;
                }
                case 28: {
                    if (tag !== 226) {
                        break;
                    }
                    message.typeOfProperty.push(exports.TypeOfProperty.decode(reader, reader.uint32()));
                    continue;
                }
                case 29: {
                    if (tag !== 232) {
                        break;
                    }
                    message.standardStatus = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            listingType: isSet(object.listingType) ? areaPageListing_ListingTypeFromJSON(object.listingType) : 0,
            statusId: isSet(object.status_id) ? areaPageListing_StatusFromJSON(object.status_id) : 0,
            price: isSet(object.price) ? exports.Range_Float.fromJSON(object.price) : undefined,
            styles: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.styles) ? object.styles.map((e) => styleFromJSON(e)) : [],
            listedDate: isSet(object.listed_date) ? exports.Range_Date.fromJSON(object.listed_date) : undefined,
            bedroomsExact: isSet(object.bedrooms_exact) ? globalThis.Number(object.bedrooms_exact) : undefined,
            bedroomsRange: isSet(object.bedrooms_range) ? exports.Range_Integer.fromJSON(object.bedrooms_range) : undefined,
            bathroomsExact: isSet(object.bathrooms_exact) ? globalThis.Number(object.bathrooms_exact) : undefined,
            bathroomsRange: isSet(object.bathrooms_range) ? exports.Range_Integer.fromJSON(object.bathrooms_range) : undefined,
            parkingExact: isSet(object.parking_exact) ? globalThis.Number(object.parking_exact) : undefined,
            parkingRange: isSet(object.parking_range) ? exports.Range_Integer.fromJSON(object.parking_range) : undefined,
            squareFeet: isSet(object.squareFeet) ? exports.Range_Float.fromJSON(object.squareFeet) : undefined,
            propertyType: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.propertyType)
                ? object.propertyType.map((e) => propertyTypeFromJSON(e))
                : [],
            hasGarage: isSet(object.garage) ? globalThis.Boolean(object.garage) : false,
            hasPool: isSet(object.pool) ? globalThis.Boolean(object.pool) : false,
            hasOpenHouse: isSet(object.openHouse) ? globalThis.Boolean(object.openHouse) : false,
            hasWaterFront: isSet(object.waterfront) ? globalThis.Boolean(object.waterfront) : false,
            hasFirePlace: isSet(object.fireplace) ? globalThis.Boolean(object.fireplace) : false,
            hasLocker: isSet(object.has_locker) ? globalThis.Boolean(object.has_locker) : false,
            maintenance: isSet(object.maintenance) ? globalThis.Number(object.maintenance) : 0,
            boundaryTopLeft: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.boundaryTopLeft)
                ? object.boundaryTopLeft.map((e) => globalThis.Number(e))
                : [],
            boundaryBottomRight: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.boundaryBottomRight)
                ? object.boundaryBottomRight.map((e) => globalThis.Number(e))
                : [],
            zoom: isSet(object.zoom) ? globalThis.Number(object.zoom) : 0,
            providerId: isSet(object.provider_id) ? (0, provider_1.providerFromJSON)(object.provider_id) : 0,
            hasImage: isSet(object.hasImage) ? globalThis.Boolean(object.hasImage) : false,
            typeOfProperty: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.typeOfProperty)
                ? object.typeOfProperty.map((e) => exports.TypeOfProperty.fromJSON(e))
                : [],
            standardStatus: isSet(object.standardStatus) ? (0, standard_status_1.standardStatusFromJSON)(object.standardStatus) : 0,
        };
    },
    toJSON(message) {
        var _a, _b, _c, _d, _e;
        const obj = {};
        if (message.listingType !== 0) {
            obj.listingType = areaPageListing_ListingTypeToJSON(message.listingType);
        }
        if (message.statusId !== 0) {
            obj.status_id = areaPageListing_StatusToJSON(message.statusId);
        }
        if (message.price !== undefined) {
            obj.price = exports.Range_Float.toJSON(message.price);
        }
        if ((_a = message.styles) === null || _a === void 0 ? void 0 : _a.length) {
            obj.styles = message.styles.map((e) => styleToJSON(e));
        }
        if (message.listedDate !== undefined) {
            obj.listed_date = exports.Range_Date.toJSON(message.listedDate);
        }
        if (message.bedroomsExact !== undefined) {
            obj.bedrooms_exact = Math.round(message.bedroomsExact);
        }
        if (message.bedroomsRange !== undefined) {
            obj.bedrooms_range = exports.Range_Integer.toJSON(message.bedroomsRange);
        }
        if (message.bathroomsExact !== undefined) {
            obj.bathrooms_exact = Math.round(message.bathroomsExact);
        }
        if (message.bathroomsRange !== undefined) {
            obj.bathrooms_range = exports.Range_Integer.toJSON(message.bathroomsRange);
        }
        if (message.parkingExact !== undefined) {
            obj.parking_exact = Math.round(message.parkingExact);
        }
        if (message.parkingRange !== undefined) {
            obj.parking_range = exports.Range_Integer.toJSON(message.parkingRange);
        }
        if (message.squareFeet !== undefined) {
            obj.squareFeet = exports.Range_Float.toJSON(message.squareFeet);
        }
        if ((_b = message.propertyType) === null || _b === void 0 ? void 0 : _b.length) {
            obj.propertyType = message.propertyType.map((e) => propertyTypeToJSON(e));
        }
        if (message.hasGarage !== false) {
            obj.garage = message.hasGarage;
        }
        if (message.hasPool !== false) {
            obj.pool = message.hasPool;
        }
        if (message.hasOpenHouse !== false) {
            obj.openHouse = message.hasOpenHouse;
        }
        if (message.hasWaterFront !== false) {
            obj.waterfront = message.hasWaterFront;
        }
        if (message.hasFirePlace !== false) {
            obj.fireplace = message.hasFirePlace;
        }
        if (message.hasLocker !== false) {
            obj.has_locker = message.hasLocker;
        }
        if (message.maintenance !== 0) {
            obj.maintenance = message.maintenance;
        }
        if ((_c = message.boundaryTopLeft) === null || _c === void 0 ? void 0 : _c.length) {
            obj.boundaryTopLeft = message.boundaryTopLeft;
        }
        if ((_d = message.boundaryBottomRight) === null || _d === void 0 ? void 0 : _d.length) {
            obj.boundaryBottomRight = message.boundaryBottomRight;
        }
        if (message.zoom !== 0) {
            obj.zoom = message.zoom;
        }
        if (message.providerId !== 0) {
            obj.provider_id = (0, provider_1.providerToJSON)(message.providerId);
        }
        if (message.hasImage !== false) {
            obj.hasImage = message.hasImage;
        }
        if ((_e = message.typeOfProperty) === null || _e === void 0 ? void 0 : _e.length) {
            obj.typeOfProperty = message.typeOfProperty.map((e) => exports.TypeOfProperty.toJSON(e));
        }
        if (message.standardStatus !== 0) {
            obj.standardStatus = (0, standard_status_1.standardStatusToJSON)(message.standardStatus);
        }
        return obj;
    },
    create(base) {
        return exports.Filter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        const message = createBaseFilter();
        message.listingType = (_a = object.listingType) !== null && _a !== void 0 ? _a : 0;
        message.statusId = (_b = object.statusId) !== null && _b !== void 0 ? _b : 0;
        message.price = (object.price !== undefined && object.price !== null)
            ? exports.Range_Float.fromPartial(object.price)
            : undefined;
        message.styles = ((_c = object.styles) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        message.listedDate = (object.listedDate !== undefined && object.listedDate !== null)
            ? exports.Range_Date.fromPartial(object.listedDate)
            : undefined;
        message.bedroomsExact = (_d = object.bedroomsExact) !== null && _d !== void 0 ? _d : undefined;
        message.bedroomsRange = (object.bedroomsRange !== undefined && object.bedroomsRange !== null)
            ? exports.Range_Integer.fromPartial(object.bedroomsRange)
            : undefined;
        message.bathroomsExact = (_e = object.bathroomsExact) !== null && _e !== void 0 ? _e : undefined;
        message.bathroomsRange = (object.bathroomsRange !== undefined && object.bathroomsRange !== null)
            ? exports.Range_Integer.fromPartial(object.bathroomsRange)
            : undefined;
        message.parkingExact = (_f = object.parkingExact) !== null && _f !== void 0 ? _f : undefined;
        message.parkingRange = (object.parkingRange !== undefined && object.parkingRange !== null)
            ? exports.Range_Integer.fromPartial(object.parkingRange)
            : undefined;
        message.squareFeet = (object.squareFeet !== undefined && object.squareFeet !== null)
            ? exports.Range_Float.fromPartial(object.squareFeet)
            : undefined;
        message.propertyType = ((_g = object.propertyType) === null || _g === void 0 ? void 0 : _g.map((e) => e)) || [];
        message.hasGarage = (_h = object.hasGarage) !== null && _h !== void 0 ? _h : false;
        message.hasPool = (_j = object.hasPool) !== null && _j !== void 0 ? _j : false;
        message.hasOpenHouse = (_k = object.hasOpenHouse) !== null && _k !== void 0 ? _k : false;
        message.hasWaterFront = (_l = object.hasWaterFront) !== null && _l !== void 0 ? _l : false;
        message.hasFirePlace = (_m = object.hasFirePlace) !== null && _m !== void 0 ? _m : false;
        message.hasLocker = (_o = object.hasLocker) !== null && _o !== void 0 ? _o : false;
        message.maintenance = (_p = object.maintenance) !== null && _p !== void 0 ? _p : 0;
        message.boundaryTopLeft = ((_q = object.boundaryTopLeft) === null || _q === void 0 ? void 0 : _q.map((e) => e)) || [];
        message.boundaryBottomRight = ((_r = object.boundaryBottomRight) === null || _r === void 0 ? void 0 : _r.map((e) => e)) || [];
        message.zoom = (_s = object.zoom) !== null && _s !== void 0 ? _s : 0;
        message.providerId = (_t = object.providerId) !== null && _t !== void 0 ? _t : 0;
        message.hasImage = (_u = object.hasImage) !== null && _u !== void 0 ? _u : false;
        message.typeOfProperty = ((_v = object.typeOfProperty) === null || _v === void 0 ? void 0 : _v.map((e) => exports.TypeOfProperty.fromPartial(e))) || [];
        message.standardStatus = (_w = object.standardStatus) !== null && _w !== void 0 ? _w : 0;
        return message;
    },
};
function createBaseAreaPageListingRequest() {
    return { sortBy: 0, filter: undefined };
}
exports.AreaPageListingRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.sortBy !== 0) {
            writer.uint32(8).int32(message.sortBy);
        }
        if (message.filter !== undefined) {
            exports.Filter.encode(message.filter, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAreaPageListingRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.sortBy = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.filter = exports.Filter.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sortBy: isSet(object.sort_by) ? sortByFromJSON(object.sort_by) : 0,
            filter: isSet(object.filter) ? exports.Filter.fromJSON(object.filter) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sortBy !== 0) {
            obj.sort_by = sortByToJSON(message.sortBy);
        }
        if (message.filter !== undefined) {
            obj.filter = exports.Filter.toJSON(message.filter);
        }
        return obj;
    },
    create(base) {
        return exports.AreaPageListingRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseAreaPageListingRequest();
        message.sortBy = (_a = object.sortBy) !== null && _a !== void 0 ? _a : 0;
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.Filter.fromPartial(object.filter)
            : undefined;
        return message;
    },
};
function createBaseAreaPageListingResponse() {
    return { data: [], PageNumber: 0, PageSize: 0, TotalCount: 0, TotalPages: 0 };
}
exports.AreaPageListingResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.data) {
            exports.AreaPageListing.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.PageNumber !== 0) {
            writer.uint32(16).uint32(message.PageNumber);
        }
        if (message.PageSize !== 0) {
            writer.uint32(24).uint32(message.PageSize);
        }
        if (message.TotalCount !== 0) {
            writer.uint32(32).uint32(message.TotalCount);
        }
        if (message.TotalPages !== 0) {
            writer.uint32(40).uint32(message.TotalPages);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAreaPageListingResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.data.push(exports.AreaPageListing.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.PageNumber = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.PageSize = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.TotalCount = reader.uint32();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.TotalPages = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map((e) => exports.AreaPageListing.fromJSON(e)) : [],
            PageNumber: isSet(object.PageNumber) ? globalThis.Number(object.PageNumber) : 0,
            PageSize: isSet(object.PageSize) ? globalThis.Number(object.PageSize) : 0,
            TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
            TotalPages: isSet(object.TotalPages) ? globalThis.Number(object.TotalPages) : 0,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.data) === null || _a === void 0 ? void 0 : _a.length) {
            obj.data = message.data.map((e) => exports.AreaPageListing.toJSON(e));
        }
        if (message.PageNumber !== 0) {
            obj.PageNumber = Math.round(message.PageNumber);
        }
        if (message.PageSize !== 0) {
            obj.PageSize = Math.round(message.PageSize);
        }
        if (message.TotalCount !== 0) {
            obj.TotalCount = Math.round(message.TotalCount);
        }
        if (message.TotalPages !== 0) {
            obj.TotalPages = Math.round(message.TotalPages);
        }
        return obj;
    },
    create(base) {
        return exports.AreaPageListingResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseAreaPageListingResponse();
        message.data = ((_a = object.data) === null || _a === void 0 ? void 0 : _a.map((e) => exports.AreaPageListing.fromPartial(e))) || [];
        message.PageNumber = (_b = object.PageNumber) !== null && _b !== void 0 ? _b : 0;
        message.PageSize = (_c = object.PageSize) !== null && _c !== void 0 ? _c : 0;
        message.TotalCount = (_d = object.TotalCount) !== null && _d !== void 0 ? _d : 0;
        message.TotalPages = (_e = object.TotalPages) !== null && _e !== void 0 ? _e : 0;
        return message;
    },
};
function createBaseAreaPageListing() {
    return {
        id: 0,
        statusId: 0,
        listingType: 0,
        propertyType: "",
        mls: "",
        slug: "",
        address: "",
        postalCode: "",
        province: "",
        neighbourhood: "",
        neighbourhoodSlug: "",
        subDivision: "",
        subDivisionSlug: "",
        price: 0,
        SoldPrice: 0,
        squareFootage: undefined,
        bedrooms: 0,
        bedroomsPartial: 0,
        bathrooms: 0,
        bathroomsPartial: 0,
        imageRootStorageKey: "",
        createdAt: undefined,
        updatedOn: undefined,
        soldAt: undefined,
        expiredAt: undefined,
        providerId: 0,
        lastStatus: "",
        addressUrlAbsolutePath: "",
        listingUrlAbsolutePath: "",
        position: "",
        hasGarage: false,
        hasPool: false,
        hasOpenHouse: false,
        hasWaterFront: false,
        hasFirePlace: false,
        hasLocker: false,
        maintenance: 0,
        streetName: "",
        streetNumber: "",
        unit: "",
        termsOfUseRequired: false,
        brokerage: "",
        imageSource: "",
        countryCode: "",
        typeOfProperty: "",
        subTypeOfProperty: "",
        expAgentId: 0,
        standardStatus: 0,
        displayAddress: undefined,
    };
}
exports.AreaPageListing = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.statusId !== 0) {
            writer.uint32(16).int32(message.statusId);
        }
        if (message.listingType !== 0) {
            writer.uint32(24).int32(message.listingType);
        }
        if (message.propertyType !== "") {
            writer.uint32(34).string(message.propertyType);
        }
        if (message.mls !== "") {
            writer.uint32(42).string(message.mls);
        }
        if (message.slug !== "") {
            writer.uint32(50).string(message.slug);
        }
        if (message.address !== "") {
            writer.uint32(58).string(message.address);
        }
        if (message.postalCode !== "") {
            writer.uint32(66).string(message.postalCode);
        }
        if (message.province !== "") {
            writer.uint32(74).string(message.province);
        }
        if (message.neighbourhood !== "") {
            writer.uint32(82).string(message.neighbourhood);
        }
        if (message.neighbourhoodSlug !== "") {
            writer.uint32(90).string(message.neighbourhoodSlug);
        }
        if (message.subDivision !== "") {
            writer.uint32(98).string(message.subDivision);
        }
        if (message.subDivisionSlug !== "") {
            writer.uint32(106).string(message.subDivisionSlug);
        }
        if (message.price !== 0) {
            writer.uint32(117).float(message.price);
        }
        if (message.SoldPrice !== 0) {
            writer.uint32(125).float(message.SoldPrice);
        }
        if (message.squareFootage !== undefined) {
            exports.AreaPageListing_IntegerRange.encode(message.squareFootage, writer.uint32(130).fork()).join();
        }
        if (message.bedrooms !== 0) {
            writer.uint32(136).uint64(message.bedrooms);
        }
        if (message.bedroomsPartial !== 0) {
            writer.uint32(144).uint64(message.bedroomsPartial);
        }
        if (message.bathrooms !== 0) {
            writer.uint32(152).uint64(message.bathrooms);
        }
        if (message.bathroomsPartial !== 0) {
            writer.uint32(160).uint64(message.bathroomsPartial);
        }
        if (message.imageRootStorageKey !== "") {
            writer.uint32(170).string(message.imageRootStorageKey);
        }
        if (message.createdAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(178).fork()).join();
        }
        if (message.updatedOn !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.updatedOn), writer.uint32(186).fork()).join();
        }
        if (message.soldAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.soldAt), writer.uint32(194).fork()).join();
        }
        if (message.expiredAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expiredAt), writer.uint32(202).fork()).join();
        }
        if (message.providerId !== 0) {
            writer.uint32(208).int32(message.providerId);
        }
        if (message.lastStatus !== "") {
            writer.uint32(218).string(message.lastStatus);
        }
        if (message.addressUrlAbsolutePath !== "") {
            writer.uint32(226).string(message.addressUrlAbsolutePath);
        }
        if (message.listingUrlAbsolutePath !== "") {
            writer.uint32(234).string(message.listingUrlAbsolutePath);
        }
        if (message.position !== "") {
            writer.uint32(242).string(message.position);
        }
        if (message.hasGarage !== false) {
            writer.uint32(248).bool(message.hasGarage);
        }
        if (message.hasPool !== false) {
            writer.uint32(256).bool(message.hasPool);
        }
        if (message.hasOpenHouse !== false) {
            writer.uint32(264).bool(message.hasOpenHouse);
        }
        if (message.hasWaterFront !== false) {
            writer.uint32(272).bool(message.hasWaterFront);
        }
        if (message.hasFirePlace !== false) {
            writer.uint32(280).bool(message.hasFirePlace);
        }
        if (message.hasLocker !== false) {
            writer.uint32(288).bool(message.hasLocker);
        }
        if (message.maintenance !== 0) {
            writer.uint32(301).float(message.maintenance);
        }
        if (message.streetName !== "") {
            writer.uint32(306).string(message.streetName);
        }
        if (message.streetNumber !== "") {
            writer.uint32(314).string(message.streetNumber);
        }
        if (message.unit !== "") {
            writer.uint32(322).string(message.unit);
        }
        if (message.termsOfUseRequired !== false) {
            writer.uint32(328).bool(message.termsOfUseRequired);
        }
        if (message.brokerage !== "") {
            writer.uint32(338).string(message.brokerage);
        }
        if (message.imageSource !== "") {
            writer.uint32(346).string(message.imageSource);
        }
        if (message.countryCode !== "") {
            writer.uint32(354).string(message.countryCode);
        }
        if (message.typeOfProperty !== "") {
            writer.uint32(362).string(message.typeOfProperty);
        }
        if (message.subTypeOfProperty !== "") {
            writer.uint32(370).string(message.subTypeOfProperty);
        }
        if (message.expAgentId !== 0) {
            writer.uint32(376).uint64(message.expAgentId);
        }
        if (message.standardStatus !== 0) {
            writer.uint32(384).int32(message.standardStatus);
        }
        if (message.displayAddress !== undefined) {
            display_1.Display.encode(message.displayAddress, writer.uint32(394).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAreaPageListing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.statusId = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.listingType = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.propertyType = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.mls = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.slug = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.address = reader.string();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.postalCode = reader.string();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.province = reader.string();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.neighbourhood = reader.string();
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.neighbourhoodSlug = reader.string();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.subDivision = reader.string();
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.subDivisionSlug = reader.string();
                    continue;
                }
                case 14: {
                    if (tag !== 117) {
                        break;
                    }
                    message.price = reader.float();
                    continue;
                }
                case 15: {
                    if (tag !== 125) {
                        break;
                    }
                    message.SoldPrice = reader.float();
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.squareFootage = exports.AreaPageListing_IntegerRange.decode(reader, reader.uint32());
                    continue;
                }
                case 17: {
                    if (tag !== 136) {
                        break;
                    }
                    message.bedrooms = longToNumber(reader.uint64());
                    continue;
                }
                case 18: {
                    if (tag !== 144) {
                        break;
                    }
                    message.bedroomsPartial = longToNumber(reader.uint64());
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.bathrooms = longToNumber(reader.uint64());
                    continue;
                }
                case 20: {
                    if (tag !== 160) {
                        break;
                    }
                    message.bathroomsPartial = longToNumber(reader.uint64());
                    continue;
                }
                case 21: {
                    if (tag !== 170) {
                        break;
                    }
                    message.imageRootStorageKey = reader.string();
                    continue;
                }
                case 22: {
                    if (tag !== 178) {
                        break;
                    }
                    message.createdAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 23: {
                    if (tag !== 186) {
                        break;
                    }
                    message.updatedOn = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 24: {
                    if (tag !== 194) {
                        break;
                    }
                    message.soldAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 25: {
                    if (tag !== 202) {
                        break;
                    }
                    message.expiredAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 26: {
                    if (tag !== 208) {
                        break;
                    }
                    message.providerId = reader.int32();
                    continue;
                }
                case 27: {
                    if (tag !== 218) {
                        break;
                    }
                    message.lastStatus = reader.string();
                    continue;
                }
                case 28: {
                    if (tag !== 226) {
                        break;
                    }
                    message.addressUrlAbsolutePath = reader.string();
                    continue;
                }
                case 29: {
                    if (tag !== 234) {
                        break;
                    }
                    message.listingUrlAbsolutePath = reader.string();
                    continue;
                }
                case 30: {
                    if (tag !== 242) {
                        break;
                    }
                    message.position = reader.string();
                    continue;
                }
                case 31: {
                    if (tag !== 248) {
                        break;
                    }
                    message.hasGarage = reader.bool();
                    continue;
                }
                case 32: {
                    if (tag !== 256) {
                        break;
                    }
                    message.hasPool = reader.bool();
                    continue;
                }
                case 33: {
                    if (tag !== 264) {
                        break;
                    }
                    message.hasOpenHouse = reader.bool();
                    continue;
                }
                case 34: {
                    if (tag !== 272) {
                        break;
                    }
                    message.hasWaterFront = reader.bool();
                    continue;
                }
                case 35: {
                    if (tag !== 280) {
                        break;
                    }
                    message.hasFirePlace = reader.bool();
                    continue;
                }
                case 36: {
                    if (tag !== 288) {
                        break;
                    }
                    message.hasLocker = reader.bool();
                    continue;
                }
                case 37: {
                    if (tag !== 301) {
                        break;
                    }
                    message.maintenance = reader.float();
                    continue;
                }
                case 38: {
                    if (tag !== 306) {
                        break;
                    }
                    message.streetName = reader.string();
                    continue;
                }
                case 39: {
                    if (tag !== 314) {
                        break;
                    }
                    message.streetNumber = reader.string();
                    continue;
                }
                case 40: {
                    if (tag !== 322) {
                        break;
                    }
                    message.unit = reader.string();
                    continue;
                }
                case 41: {
                    if (tag !== 328) {
                        break;
                    }
                    message.termsOfUseRequired = reader.bool();
                    continue;
                }
                case 42: {
                    if (tag !== 338) {
                        break;
                    }
                    message.brokerage = reader.string();
                    continue;
                }
                case 43: {
                    if (tag !== 346) {
                        break;
                    }
                    message.imageSource = reader.string();
                    continue;
                }
                case 44: {
                    if (tag !== 354) {
                        break;
                    }
                    message.countryCode = reader.string();
                    continue;
                }
                case 45: {
                    if (tag !== 362) {
                        break;
                    }
                    message.typeOfProperty = reader.string();
                    continue;
                }
                case 46: {
                    if (tag !== 370) {
                        break;
                    }
                    message.subTypeOfProperty = reader.string();
                    continue;
                }
                case 47: {
                    if (tag !== 376) {
                        break;
                    }
                    message.expAgentId = longToNumber(reader.uint64());
                    continue;
                }
                case 48: {
                    if (tag !== 384) {
                        break;
                    }
                    message.standardStatus = reader.int32();
                    continue;
                }
                case 49: {
                    if (tag !== 394) {
                        break;
                    }
                    message.displayAddress = display_1.Display.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            statusId: isSet(object.status_id) ? areaPageListing_StatusFromJSON(object.status_id) : 0,
            listingType: isSet(object.listing_type) ? areaPageListing_ListingTypeFromJSON(object.listing_type) : 0,
            propertyType: isSet(object.property_type) ? globalThis.String(object.property_type) : "",
            mls: isSet(object.mls) ? globalThis.String(object.mls) : "",
            slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            address: isSet(object.address) ? globalThis.String(object.address) : "",
            postalCode: isSet(object.postal_code) ? globalThis.String(object.postal_code) : "",
            province: isSet(object.province) ? globalThis.String(object.province) : "",
            neighbourhood: isSet(object.neighbourhood) ? globalThis.String(object.neighbourhood) : "",
            neighbourhoodSlug: isSet(object.neighbourhood_slug) ? globalThis.String(object.neighbourhood_slug) : "",
            subDivision: isSet(object.sub_division) ? globalThis.String(object.sub_division) : "",
            subDivisionSlug: isSet(object.sub_division_slug) ? globalThis.String(object.sub_division_slug) : "",
            price: isSet(object.price) ? globalThis.Number(object.price) : 0,
            SoldPrice: isSet(object.sold_price) ? globalThis.Number(object.sold_price) : 0,
            squareFootage: isSet(object.square_footage)
                ? exports.AreaPageListing_IntegerRange.fromJSON(object.square_footage)
                : undefined,
            bedrooms: isSet(object.bedrooms) ? globalThis.Number(object.bedrooms) : 0,
            bedroomsPartial: isSet(object.bedrooms_partial) ? globalThis.Number(object.bedrooms_partial) : 0,
            bathrooms: isSet(object.bathrooms) ? globalThis.Number(object.bathrooms) : 0,
            bathroomsPartial: isSet(object.bathrooms_partial) ? globalThis.Number(object.bathrooms_partial) : 0,
            imageRootStorageKey: isSet(object.image_root_storage_key) ? globalThis.String(object.image_root_storage_key) : "",
            createdAt: isSet(object.created_at) ? fromJsonTimestamp(object.created_at) : undefined,
            updatedOn: isSet(object.updated_on) ? fromJsonTimestamp(object.updated_on) : undefined,
            soldAt: isSet(object.sold_at) ? fromJsonTimestamp(object.sold_at) : undefined,
            expiredAt: isSet(object.expired_at) ? fromJsonTimestamp(object.expired_at) : undefined,
            providerId: isSet(object.provider_id) ? (0, provider_1.providerFromJSON)(object.provider_id) : 0,
            lastStatus: isSet(object.last_status) ? globalThis.String(object.last_status) : "",
            addressUrlAbsolutePath: isSet(object.address_url_absolute_path)
                ? globalThis.String(object.address_url_absolute_path)
                : "",
            listingUrlAbsolutePath: isSet(object.listing_url_absolute_path)
                ? globalThis.String(object.listing_url_absolute_path)
                : "",
            position: isSet(object.position) ? globalThis.String(object.position) : "",
            hasGarage: isSet(object.garage) ? globalThis.Boolean(object.garage) : false,
            hasPool: isSet(object.pool) ? globalThis.Boolean(object.pool) : false,
            hasOpenHouse: isSet(object.openHouse) ? globalThis.Boolean(object.openHouse) : false,
            hasWaterFront: isSet(object.waterfront) ? globalThis.Boolean(object.waterfront) : false,
            hasFirePlace: isSet(object.fireplace) ? globalThis.Boolean(object.fireplace) : false,
            hasLocker: isSet(object.has_locker) ? globalThis.Boolean(object.has_locker) : false,
            maintenance: isSet(object.maintenance) ? globalThis.Number(object.maintenance) : 0,
            streetName: isSet(object.street_name) ? globalThis.String(object.street_name) : "",
            streetNumber: isSet(object.street_number) ? globalThis.String(object.street_number) : "",
            unit: isSet(object.unit) ? globalThis.String(object.unit) : "",
            termsOfUseRequired: isSet(object.terms_of_use_required)
                ? globalThis.Boolean(object.terms_of_use_required)
                : false,
            brokerage: isSet(object.brokerage) ? globalThis.String(object.brokerage) : "",
            imageSource: isSet(object.image_source) ? globalThis.String(object.image_source) : "",
            countryCode: isSet(object.country_code) ? globalThis.String(object.country_code) : "",
            typeOfProperty: isSet(object.typeOfProperty) ? globalThis.String(object.typeOfProperty) : "",
            subTypeOfProperty: isSet(object.subTypeOfProperty) ? globalThis.String(object.subTypeOfProperty) : "",
            expAgentId: isSet(object.expAgentId) ? globalThis.Number(object.expAgentId) : 0,
            standardStatus: isSet(object.standardStatus) ? (0, standard_status_1.standardStatusFromJSON)(object.standardStatus) : 0,
            displayAddress: isSet(object.display_address) ? display_1.Display.fromJSON(object.display_address) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.statusId !== 0) {
            obj.status_id = areaPageListing_StatusToJSON(message.statusId);
        }
        if (message.listingType !== 0) {
            obj.listing_type = areaPageListing_ListingTypeToJSON(message.listingType);
        }
        if (message.propertyType !== "") {
            obj.property_type = message.propertyType;
        }
        if (message.mls !== "") {
            obj.mls = message.mls;
        }
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if (message.address !== "") {
            obj.address = message.address;
        }
        if (message.postalCode !== "") {
            obj.postal_code = message.postalCode;
        }
        if (message.province !== "") {
            obj.province = message.province;
        }
        if (message.neighbourhood !== "") {
            obj.neighbourhood = message.neighbourhood;
        }
        if (message.neighbourhoodSlug !== "") {
            obj.neighbourhood_slug = message.neighbourhoodSlug;
        }
        if (message.subDivision !== "") {
            obj.sub_division = message.subDivision;
        }
        if (message.subDivisionSlug !== "") {
            obj.sub_division_slug = message.subDivisionSlug;
        }
        if (message.price !== 0) {
            obj.price = message.price;
        }
        if (message.SoldPrice !== 0) {
            obj.sold_price = message.SoldPrice;
        }
        if (message.squareFootage !== undefined) {
            obj.square_footage = exports.AreaPageListing_IntegerRange.toJSON(message.squareFootage);
        }
        if (message.bedrooms !== 0) {
            obj.bedrooms = Math.round(message.bedrooms);
        }
        if (message.bedroomsPartial !== 0) {
            obj.bedrooms_partial = Math.round(message.bedroomsPartial);
        }
        if (message.bathrooms !== 0) {
            obj.bathrooms = Math.round(message.bathrooms);
        }
        if (message.bathroomsPartial !== 0) {
            obj.bathrooms_partial = Math.round(message.bathroomsPartial);
        }
        if (message.imageRootStorageKey !== "") {
            obj.image_root_storage_key = message.imageRootStorageKey;
        }
        if (message.createdAt !== undefined) {
            obj.created_at = message.createdAt.toISOString();
        }
        if (message.updatedOn !== undefined) {
            obj.updated_on = message.updatedOn.toISOString();
        }
        if (message.soldAt !== undefined) {
            obj.sold_at = message.soldAt.toISOString();
        }
        if (message.expiredAt !== undefined) {
            obj.expired_at = message.expiredAt.toISOString();
        }
        if (message.providerId !== 0) {
            obj.provider_id = (0, provider_1.providerToJSON)(message.providerId);
        }
        if (message.lastStatus !== "") {
            obj.last_status = message.lastStatus;
        }
        if (message.addressUrlAbsolutePath !== "") {
            obj.address_url_absolute_path = message.addressUrlAbsolutePath;
        }
        if (message.listingUrlAbsolutePath !== "") {
            obj.listing_url_absolute_path = message.listingUrlAbsolutePath;
        }
        if (message.position !== "") {
            obj.position = message.position;
        }
        if (message.hasGarage !== false) {
            obj.garage = message.hasGarage;
        }
        if (message.hasPool !== false) {
            obj.pool = message.hasPool;
        }
        if (message.hasOpenHouse !== false) {
            obj.openHouse = message.hasOpenHouse;
        }
        if (message.hasWaterFront !== false) {
            obj.waterfront = message.hasWaterFront;
        }
        if (message.hasFirePlace !== false) {
            obj.fireplace = message.hasFirePlace;
        }
        if (message.hasLocker !== false) {
            obj.has_locker = message.hasLocker;
        }
        if (message.maintenance !== 0) {
            obj.maintenance = message.maintenance;
        }
        if (message.streetName !== "") {
            obj.street_name = message.streetName;
        }
        if (message.streetNumber !== "") {
            obj.street_number = message.streetNumber;
        }
        if (message.unit !== "") {
            obj.unit = message.unit;
        }
        if (message.termsOfUseRequired !== false) {
            obj.terms_of_use_required = message.termsOfUseRequired;
        }
        if (message.brokerage !== "") {
            obj.brokerage = message.brokerage;
        }
        if (message.imageSource !== "") {
            obj.image_source = message.imageSource;
        }
        if (message.countryCode !== "") {
            obj.country_code = message.countryCode;
        }
        if (message.typeOfProperty !== "") {
            obj.typeOfProperty = message.typeOfProperty;
        }
        if (message.subTypeOfProperty !== "") {
            obj.subTypeOfProperty = message.subTypeOfProperty;
        }
        if (message.expAgentId !== 0) {
            obj.expAgentId = Math.round(message.expAgentId);
        }
        if (message.standardStatus !== 0) {
            obj.standardStatus = (0, standard_status_1.standardStatusToJSON)(message.standardStatus);
        }
        if (message.displayAddress !== undefined) {
            obj.display_address = display_1.Display.toJSON(message.displayAddress);
        }
        return obj;
    },
    create(base) {
        return exports.AreaPageListing.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22;
        const message = createBaseAreaPageListing();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.statusId = (_b = object.statusId) !== null && _b !== void 0 ? _b : 0;
        message.listingType = (_c = object.listingType) !== null && _c !== void 0 ? _c : 0;
        message.propertyType = (_d = object.propertyType) !== null && _d !== void 0 ? _d : "";
        message.mls = (_e = object.mls) !== null && _e !== void 0 ? _e : "";
        message.slug = (_f = object.slug) !== null && _f !== void 0 ? _f : "";
        message.address = (_g = object.address) !== null && _g !== void 0 ? _g : "";
        message.postalCode = (_h = object.postalCode) !== null && _h !== void 0 ? _h : "";
        message.province = (_j = object.province) !== null && _j !== void 0 ? _j : "";
        message.neighbourhood = (_k = object.neighbourhood) !== null && _k !== void 0 ? _k : "";
        message.neighbourhoodSlug = (_l = object.neighbourhoodSlug) !== null && _l !== void 0 ? _l : "";
        message.subDivision = (_m = object.subDivision) !== null && _m !== void 0 ? _m : "";
        message.subDivisionSlug = (_o = object.subDivisionSlug) !== null && _o !== void 0 ? _o : "";
        message.price = (_p = object.price) !== null && _p !== void 0 ? _p : 0;
        message.SoldPrice = (_q = object.SoldPrice) !== null && _q !== void 0 ? _q : 0;
        message.squareFootage = (object.squareFootage !== undefined && object.squareFootage !== null)
            ? exports.AreaPageListing_IntegerRange.fromPartial(object.squareFootage)
            : undefined;
        message.bedrooms = (_r = object.bedrooms) !== null && _r !== void 0 ? _r : 0;
        message.bedroomsPartial = (_s = object.bedroomsPartial) !== null && _s !== void 0 ? _s : 0;
        message.bathrooms = (_t = object.bathrooms) !== null && _t !== void 0 ? _t : 0;
        message.bathroomsPartial = (_u = object.bathroomsPartial) !== null && _u !== void 0 ? _u : 0;
        message.imageRootStorageKey = (_v = object.imageRootStorageKey) !== null && _v !== void 0 ? _v : "";
        message.createdAt = (_w = object.createdAt) !== null && _w !== void 0 ? _w : undefined;
        message.updatedOn = (_x = object.updatedOn) !== null && _x !== void 0 ? _x : undefined;
        message.soldAt = (_y = object.soldAt) !== null && _y !== void 0 ? _y : undefined;
        message.expiredAt = (_z = object.expiredAt) !== null && _z !== void 0 ? _z : undefined;
        message.providerId = (_0 = object.providerId) !== null && _0 !== void 0 ? _0 : 0;
        message.lastStatus = (_1 = object.lastStatus) !== null && _1 !== void 0 ? _1 : "";
        message.addressUrlAbsolutePath = (_2 = object.addressUrlAbsolutePath) !== null && _2 !== void 0 ? _2 : "";
        message.listingUrlAbsolutePath = (_3 = object.listingUrlAbsolutePath) !== null && _3 !== void 0 ? _3 : "";
        message.position = (_4 = object.position) !== null && _4 !== void 0 ? _4 : "";
        message.hasGarage = (_5 = object.hasGarage) !== null && _5 !== void 0 ? _5 : false;
        message.hasPool = (_6 = object.hasPool) !== null && _6 !== void 0 ? _6 : false;
        message.hasOpenHouse = (_7 = object.hasOpenHouse) !== null && _7 !== void 0 ? _7 : false;
        message.hasWaterFront = (_8 = object.hasWaterFront) !== null && _8 !== void 0 ? _8 : false;
        message.hasFirePlace = (_9 = object.hasFirePlace) !== null && _9 !== void 0 ? _9 : false;
        message.hasLocker = (_10 = object.hasLocker) !== null && _10 !== void 0 ? _10 : false;
        message.maintenance = (_11 = object.maintenance) !== null && _11 !== void 0 ? _11 : 0;
        message.streetName = (_12 = object.streetName) !== null && _12 !== void 0 ? _12 : "";
        message.streetNumber = (_13 = object.streetNumber) !== null && _13 !== void 0 ? _13 : "";
        message.unit = (_14 = object.unit) !== null && _14 !== void 0 ? _14 : "";
        message.termsOfUseRequired = (_15 = object.termsOfUseRequired) !== null && _15 !== void 0 ? _15 : false;
        message.brokerage = (_16 = object.brokerage) !== null && _16 !== void 0 ? _16 : "";
        message.imageSource = (_17 = object.imageSource) !== null && _17 !== void 0 ? _17 : "";
        message.countryCode = (_18 = object.countryCode) !== null && _18 !== void 0 ? _18 : "";
        message.typeOfProperty = (_19 = object.typeOfProperty) !== null && _19 !== void 0 ? _19 : "";
        message.subTypeOfProperty = (_20 = object.subTypeOfProperty) !== null && _20 !== void 0 ? _20 : "";
        message.expAgentId = (_21 = object.expAgentId) !== null && _21 !== void 0 ? _21 : 0;
        message.standardStatus = (_22 = object.standardStatus) !== null && _22 !== void 0 ? _22 : 0;
        message.displayAddress = (object.displayAddress !== undefined && object.displayAddress !== null)
            ? display_1.Display.fromPartial(object.displayAddress)
            : undefined;
        return message;
    },
};
function createBaseAreaPageListing_IntegerRange() {
    return { gt: undefined, gte: undefined, lt: undefined, lte: undefined };
}
exports.AreaPageListing_IntegerRange = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.gt !== undefined) {
            writer.uint32(8).int32(message.gt);
        }
        if (message.gte !== undefined) {
            writer.uint32(16).int32(message.gte);
        }
        if (message.lt !== undefined) {
            writer.uint32(24).int32(message.lt);
        }
        if (message.lte !== undefined) {
            writer.uint32(32).int32(message.lte);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAreaPageListing_IntegerRange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.gt = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.gte = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.lt = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.lte = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            gt: isSet(object.gt) ? globalThis.Number(object.gt) : undefined,
            gte: isSet(object.gte) ? globalThis.Number(object.gte) : undefined,
            lt: isSet(object.lt) ? globalThis.Number(object.lt) : undefined,
            lte: isSet(object.lte) ? globalThis.Number(object.lte) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.gt !== undefined) {
            obj.gt = Math.round(message.gt);
        }
        if (message.gte !== undefined) {
            obj.gte = Math.round(message.gte);
        }
        if (message.lt !== undefined) {
            obj.lt = Math.round(message.lt);
        }
        if (message.lte !== undefined) {
            obj.lte = Math.round(message.lte);
        }
        return obj;
    },
    create(base) {
        return exports.AreaPageListing_IntegerRange.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseAreaPageListing_IntegerRange();
        message.gt = (_a = object.gt) !== null && _a !== void 0 ? _a : undefined;
        message.gte = (_b = object.gte) !== null && _b !== void 0 ? _b : undefined;
        message.lt = (_c = object.lt) !== null && _c !== void 0 ? _c : undefined;
        message.lte = (_d = object.lte) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=area_page.js.map